// prettier-ignore

export default {
  "staking": {
    "title": "{{qbxCurrency}} Staking",
    "next-staking-distribution": "Next staking reward snapshot in: <strong><0></0></strong>",
    "desc": "Your available {{qbxCurrency}} are staked automatically, as long as you don't claim them. Get 1 VIR per {{value}} staked {{qbxCurrency}} every week!",
    "total-already-claimed": "Total {{virCurrency}} already claimed",
    "claim-vir": "Claim {{virCurrency}}",
    "next-claim-in": "Next {{virCurrency}} claim in <0></0>",
    "up-to": "up to",
    "connect": "Connect",
    "connect-account-claim": "Claim {{virCurrency}} staking reward",
    "connect-account-claim-desc": "Connect your <0>QBX VIP Club account</0> to claim your {{virCurrency}}.",
    "required-field": "This field is required.",
    "invalid-account-number": "Please enter a correct account number.",
    "vip-club-account-number": "QBX VIP Club account number",
    "staking-title": "Your $QBX Staking Reward",
    "staking-desc": "Earn weekly staking rewards at {{value}}% APY on your unclaimed $QBX tokens. This reward is only available for the first three months through this claim & stake dashboard.",
    "claim-reward": "CLAIM $QBX reward",
    "staking-reward-apy": "Staking reward APY",
    "current-unclaimed": "Current unclaimed $QBX",
    "available-staking": "Available $QBX reward",
    "your-wallet-balance": "Your $QBX Wallet Balance",
    "stay-vested-and-get-staking": "Stay Vested and Get Staking",
    "stay-vested": "Stay Vested",
    "understand-claiming": "I understand that the choice between claiming my vested tokens in {{qbxCurrency}} or {{virCurrency}} is permanent and I cannot switch between them for future claims.",
    "receive-vir-note": "It may take up to 20 minutes to receive the VIR.",
    "staking-ended": "The claim page staking rewards period has ended. You can stake your QBX and earn staking rewards <0>here in the QBX VIP Club</0>.",
    "continue-staking": "Maximize your rewards today: Stake in the VIP Club",
    "continue-staking-desc": "The claim page staking rewards period has ended... but you can continue staking your QBX and earn staking rewards in the QBX VIP Club",
    "rewards-such-as-entertainment": "Rewards such as the entertainment perks are waiting for you!",
    "stake": "Stake $QBX"
  },
  "home": {
    "connect-wallet": "Connect Wallet",
    "welcome-text": "Welcome to the $QBX claiming & staking dashboard!",
    "welcome-desc": "On this dashboard you can claim your $QBX allocation or leave it unclaimed to earn weekly $QBX rewards!",
    "connect-to-claim": "Connect your wallet to get started:",
    "no-allocation": "Your connected wallet is not eligible for a $QBX allocation, try a different wallet:",
    "connect-other-wallet": "Connect Other Wallet",
    "faqs": "FAQs",
    "claim": "Claim {{qbxCurrency}}",
    "unstake-claim": "Unstake & Claim",
    "claim-reward": "Claim Reward",
    "your-allocation": "Your {{qbxCurrency}} allocation",
    "your-claimed": "Your claimed {{currency}}",
    "your-locked": "Your locked {{qbxCurrency}}",
    "available-to-claim": "Available {{currency}} to claim",
    "your-vesting-schedule": "Your vesting schedule",
    "locked": "{{value}}% Locked",
    "unlocked": "{{value}}% Unlocked",
    "qbx-or-vir": "{{qbxCurrency}} or {{virCurrency}}",
    "claim-tap-title": "Unstake & claim your {{label}}",
    "claim-tap-desc": "Maximize your benefits with $QBX! Choose to stay vested and stake your tokens for more rewards, or claim your {{label}} now. ",
    "claim-your": "Unstake & claim your {{qbxCurrency}}",
    "claim-desc": "You are about to unstake and claim the following amount of {{qbxCurrency}}.",
    "claimed-note": "<strong>Important:</strong> After claiming your $QBX, your tokens will no longer be staked, and you will no longer earn weekly staking rewards.",
    "you-successfully-connected": "You have successfully connected QBX VIP Club account.",
    "claimed-vir-title": "Claimed {{virCurrency}}",
    "claimed-vir-desc": "You have successfully claimed your {{virCurrency}}.",
    "claimed-qbx-title": "Claimed {{qbxCurrency}}",
    "claimed-qbx-desc": "You have successfully claimed your {{qbxCurrency}}.",
    "something-went-wrong": "Something went wrong, please try again.",
    "rejected-transaction-request": "You have rejected the transaction request.",
    "transaction-processing": "Your transaction is being processed. Please wait a moment.",
    "view-your-allocation": "View your {{qbxCurrency}} allocation, vesting schedule, and claim your {{currency}}.",
    "copy-right-text": "Copyright © {{year}} qiibee foundation - All Rights Reserved",
    "go-to-website": "Go To Website",
    "claims-data": {
      "ecosystem_community": {
        "name": "Ecosystem & Community {{qbxCurrency}} Claim",
        "terms": "100% vested for 60 months with daily linear unlock"
      },
      "team": {
        "name": "Team {{qbxCurrency}} Claim",
        "terms": "100% locked with 9 months cliff and then vested for 33 months with daily linear unlock"
      },
      "strategics": {
        "name": "Strategics {{qbxCurrency}} Claim",
        "terms": "100% locked with 6 months cliff and then vested for 24 months with daily linear unlock"
      },
      "private_sale": {
        "name": "Private Sale {{qbxCurrency}} Claim",
        "terms": "10% unlocked at TGE, 90% locked with 3 months cliff and then vested for 12 months with daily linear unlock"
      },
      "community_pre_sale": {
        "name": "Community Pre-Sale {{qbxCurrency}} Claim",
        "terms": "20% unlocked at TGE, 80% locked with 1 month cliff and then vested for 12 months with daily linear unlock"
      },
      "brands_partners": {
        "name": "Brands & Partners {{qbxCurrency}} Claim",
        "terms": "5% unlocked at TGE, 95% locked with 2 months cliff and then vested for 12 months with daily linear unlock"
      },
      "founders_key_leaderboard": {
        "name": "QBX Founders Key Leaderboard Reward {{qbxCurrency}} Claim",
        "terms": "20% unlocked at TGE, 80% locked with 1 month cliff and then vested for 12 months with daily linear unlock"
      },
      "quest_tap_pool": {
        "name": "Quest & Tap Pool {{qbxCurrency}} Claim",
        "terms": "20% unlocked at TGE, 80% vested for 6 months with daily linear unlock"
      },
      "holders_unlock": {
        "name": "5 Years Holders Unlock {{qbxCurrency}} Claim",
        "terms": "100% unlocked at TGE"
      },
      "holders_unlock_multifarm": {
        "name": "Multifarm Pool {{qbxCurrency}} Claim",
        "terms": "100% unlocked at TGE"
      }
    }
  },
  "common": {
    "cancel": "Cancel",
    "close": "Close"
  }
}
